import { shake } from 'radashi'

// removes empty query parameters
export default defineNuxtRouteMiddleware((to) => {
  if (Object.values(to.query).some(value => !value)) {
    return navigateTo({
      ...to,
      query: shake(to.query, value => !value),
    }, {
      replace: true,
    })
  }
})
